import React from 'react';

const CriminologyPoliceAdministration = () => {
  return (
    <div>
      CriminologyPoliceAdministration
      CriminologyPoliceAdministration
    </div>
  );
}

export default CriminologyPoliceAdministration;
